import { MILLIMETER_SCALE } from '@editor/config/constants'
import { UNIT_PRECISION_DEFAULT } from '@editor/pages/projects/inspection-sheet/constants'
import Decimal from 'decimal.js'

/**
 * 任意の桁で四捨五入する関数
 * @param {number} num 四捨五入する数値
 * @param {string} decimalBase numをdecimalBaseで整数化したときに、どの桁まで残すか。decimalBaseの1つ下の位で四捨五入する
 * @return {number} 四捨五入した値
 */
export const roundNumber = (
  num: number,
  decimalBase: '0.0000001' | '0.000001' | '0.00001' | '0.0001' | '0.001' | '0.01' | '0.1' | '1',
) => {
  //* decimalBaseの0の数をカウント
  const zeroMatch = decimalBase.match(/0/g)
  const zeroCount = zeroMatch ? zeroMatch.length : 0
  //* 丸め誤差対策のため、decimalBaseを整数値に変換
  const intDecimalBase = 10 ** zeroCount
  return Math.round(num * intDecimalBase) / intDecimalBase
}

export const zeroPad = (num: number, places: number) => String(num).padStart(places, '0')

//* ミリメートルからメートルへ変換（丸め誤差対策）
export const millimeterToMeter = (value: number) => new Decimal(value).div(MILLIMETER_SCALE).toNumber()

//* メートルからミリメートルへ変換（丸め誤差対策）
export const meterToMillimeter = (value: number) => new Decimal(value).mul(MILLIMETER_SCALE).toNumber()

export const meterToMilimeterWhole = (v: number): number => Math.round(meterToMillimeter(v))

export const meterToMilimeterRounded = (v: number): number => roundNumber(meterToMillimeter(v), '0.01')

export const meterRounded = (v: number): number => roundNumber(v, '0.0001')

/**
 * Round distance to milimeters
 * @param distance in meters
 * @returns distance in milimeters
 */
export const roundDistance = (distance: number): number => roundNumber(meterToMillimeter(distance), '0.0001')

/**
 * Round volume. Precision of volume from tekkin-detector is 5 decimal places.
 * @param volume in meters
 * @returns roundedvolume
 */
export const roundVolume = (volume: number): number => roundNumber(volume, UNIT_PRECISION_DEFAULT)

/**
 * Convert bytes into human readable format
 * @param bytes number of bytes
 * @returns human readable string
 */
export const bytesToHumanReadable = (bytes: number): string => {
  if (bytes === 0) return '0B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / k ** i).toFixed(2))} ${sizes[i]}`
}
